import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { MainContext } from "../../../../main/context/MainContextProvider";
import { useContext } from "react";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { getNumDaysMonth } from "../../../dashboard/helpers/format-number";

export default function PRPerformedAndIrradiationChart() {
  const { relatorioMensal } = useContext(MainContext);

  const numDaysMonth = getNumDaysMonth(
    relatorioMensal?.mesDeReferencia ?? 0,
    relatorioMensal?.anoDeReferencia ?? 0
  );
  const dias = Array.from({ length: numDaysMonth }, (_, i) => i + 1);
  const diasPrevisto = dias.map(
    (dia) =>
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]
        ?.irradiacaoPrevista ?? null
  );
  const diasRealizado = dias.map(
    (dia) =>
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]
        ?.irradiacaoRealizada ?? null
  );
  const diasIrradiacaoRealizada = dias.map(
    (dia) =>
      relatorioMensal?.prIrradiacaoPrevistoRealizadoByDate?.[dia]
        ?.irradiacaoRealizada ?? null
  );
  const toleranciaPrevisto = 0.05; // 5%

  const faixaText = dias.map(
    (f) => `${f}${`/${relatorioMensal?.mesDeReferencia}`}`
  );
  const placeholder = diasPrevisto.map((p) => {
    if (p === null) {
      return null;
    }
    return p - p * toleranciaPrevisto;
  });
  const areaToleranciaPrevisto = diasPrevisto.map((p) => {
    if (p === null) {
      return null;
    }
    return p * toleranciaPrevisto;
  });

  const options: EChartsOption = {
    title: {
      text: "PR Realizado e Irradiação Realizada",
      textStyle: {
        fontSize: 12,
      },
    },
    backgroundColor: "transparent",
    grid: {
      left: 25,
      right: 35,
      bottom: 0,
      top: 30,
      containLabel: true,
    },

    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        data: faixaText,
        axisLabel: {
          rotate: 85,
          fontSize: 10,
        },
      },
    ],

    yAxis: [
      {
        type: "value",
      },
      {
        type: "value",
        name: "PR Realizado",
      },
    ],

    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },

    series: [
      {
        name: "Placeholder",
        type: "line",
        stack: "Total",
        areaStyle: {
          color: "transparent",
        },
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        data: placeholder.map((p) => p ?? "-"),
      },
      {
        name: "Abaixo",
        type: "line",
        stack: "Total",
        areaStyle: {
          color: "#fac858",
        },
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        data: areaToleranciaPrevisto.map((p) => p ?? "-"),
      },

      {
        name: "Acima",
        type: "line",
        stack: "Total",
        areaStyle: {
          color: "#92cc75",
        },
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        data: areaToleranciaPrevisto.map((p) => p ?? "-"),
      },
      {
        name: "Irradiação Realizada",
        type: "line",
        color: "#212121",
        data: diasIrradiacaoRealizada.map((p) => p ?? "-"),
        yAxisIndex: 0,
      },
      {
        name: "Pr Realizado",
        type: "line",
        color: "#212121",
        data: diasRealizado.map((p) => p ?? "-"),
        yAxisIndex: 1,
      },
    ],
  };

  const hasData =
    placeholder ||
    areaToleranciaPrevisto ||
    diasIrradiacaoRealizada ||
    diasRealizado;

  return (
    <>
      {hasData ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90%",
            width: "100%",
          }}
        >
          <RopChart option={options} />
        </Container>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title="Nenhum dado encontrado!" />
        </Box>
      )}
    </>
  );
}
